import React from 'react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { TrendingUp, BarChart3 } from 'lucide-react';
import { format } from 'date-fns';

const PerformanceCharts = ({ analyticsHistory }) => {
  const trafficData = analyticsHistory?.map(item => ({
    date: format(new Date(item?.date), 'dd/MM'),
    'Trafic': item?.organic_traffic,
    'Clics': item?.clicks
  })) || [];

  const ctrData = analyticsHistory?.map(item => ({
    date: format(new Date(item?.date), 'dd/MM'),
    'CTR (%)': parseFloat(item?.ctr?.toFixed(2)),
    'Position': item?.average_position
  })) || [];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Traffic Trend Chart */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center mb-4">
          <TrendingUp className="w-6 h-6 text-green-600 mr-2" />
          <h3 className="text-lg font-semibold text-gray-900">Évolution du trafic</h3>
        </div>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={trafficData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="Trafic" stroke="#10b981" strokeWidth={2} />
            <Line type="monotone" dataKey="Clics" stroke="#3b82f6" strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* CTR and Position Chart */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center mb-4">
          <BarChart3 className="w-6 h-6 text-green-600 mr-2" />
          <h3 className="text-lg font-semibold text-gray-900">CTR et Position moyenne</h3>
        </div>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={ctrData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis yAxisId="left" />
            <YAxis yAxisId="right" orientation="right" />
            <Tooltip />
            <Legend />
            <Bar yAxisId="left" dataKey="CTR (%)" fill="#10b981" />
            <Bar yAxisId="right" dataKey="Position" fill="#f59e0b" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PerformanceCharts;